export enum ColumnTypes {
    EVENT_TYPE = 'type',
    EVENT_SOURCE = 'source',
    EVENT_CODE = 'code',
    EVENT_DESCRIPTION = 'description',
    LAST_UPDATED = 'updateDate',
    AUTHOR = 'authorEmail',
    STATUS = 'status',
    DUE_DATE = 'dueDate',
}

export enum SortingColumnTypes {
    EVENT_TYPE = 'event.type',
    EVENT_SOURCE = 'event.source',
    EVENT_CODE = 'event.code',
    EVENT_DESCRIPTION = 'event.description',
    LAST_UPDATED = 'updateDate',
    AUTHOR = 'authorEmail',
    STATUS = 'status',
    DUE_DATE = 'dueDate',
}

export const COLUMN_CAPTIONS = {
    [ColumnTypes.EVENT_TYPE]: 'Event Type',
    [ColumnTypes.EVENT_SOURCE]: 'Event Source',
    [ColumnTypes.EVENT_CODE]: 'Event Code',
    [ColumnTypes.EVENT_DESCRIPTION]: 'Event Description',
    [ColumnTypes.LAST_UPDATED]: 'Last Updated',
    [ColumnTypes.AUTHOR]: 'Author',
    [ColumnTypes.STATUS]: 'Status',
    [ColumnTypes.DUE_DATE]: 'Due Date',
};

export const ColumnWidth = {
    [ColumnTypes.EVENT_TYPE]: '11rem',
    [ColumnTypes.EVENT_SOURCE]: '11rem',
    [ColumnTypes.EVENT_CODE]: '10%',
    [ColumnTypes.EVENT_DESCRIPTION]: 'calc(90% - 47rem)',
    [ColumnTypes.LAST_UPDATED]: '10rem',
    [ColumnTypes.AUTHOR]: '18rem',
    [ColumnTypes.STATUS]: '9rem',
    [ColumnTypes.DUE_DATE]: '9rem',
};
